<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 11 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 6.27L0 0.77L0.77 0L5.5 4.73L10.23 0L11 0.77L5.5 6.27Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 11,
  },
  height: {
    type: [String, Number],
    default: 7,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>